import {
  Stack,
  Typography
} from '@mui/material';

import { IndexFredCode } from 'generated/graphql';
import { dataUtil } from 'modules/common';
import { theme } from 'theme';



export type CustomToolTipProps = {
  type?: IndexFredCode | 'AREA' | 'BAR' | 'EPS';
  active: boolean;
  payload: { name: string; value?: string; rate?: string }[];
  label: string;
};

export const FC = (props: CustomToolTipProps) => {

  if (props.active && props.payload && props.payload.length && props.type === 'BAR') {
    return (
      <Stack
        sx={{
          // transform: 'rotate(-90deg)',
          // bgcolor: 'black'
        }}
        direction='column'
      >
        <Typography variant='toolTip' color={theme.palette.primary.main}>{props.payload[0].value}</Typography>
      </Stack>
    );
  } else if (props.active && props.payload && props.payload.length && props.type === 'AREA') {
    return (
      <Stack direction='column'>
        <Typography variant='toolTip'>{props.label}</Typography>
        <Typography variant='toolTip'>{props.payload[0].value}%</Typography>
      </Stack>
    );
  } else if (props.active && props.payload && props.payload.length && props.type === 'GDP') {
    return (
      <Stack
        borderRadius='.5rem'
        padding='1rem'
        bgcolor='white'
        direction='column'
      >
        <Typography variant='toolTip'>{props.label}</Typography>
        <Typography variant='toolTip'>{Number(props.payload[0].value).toFixed(1)}%</Typography>
      </Stack>
    );
  } else if (props.active && props.payload && props.payload.length && props.type === 'EPS') {
    return (
      <Stack
        borderRadius='.5rem'
        padding='1rem'
        bgcolor='white'
        direction='column'
      >
        <Typography variant='toolTip'>{props.label.toUpperCase()} EPS</Typography>
        <Typography variant='toolTip'>{Number(props.payload[0].value)}</Typography>
      </Stack>
    );
  } else {
    return (
      <Stack
        borderRadius='.5rem'
        padding='1rem'
        bgcolor='white'
        direction='column'
      >
        <Typography variant='toolTip'>{props.label?.toUpperCase()}</Typography>
        <Typography variant='toolTip'>{dataUtil.formatWithComma(Number(props.payload[0]?.value))}</Typography>
      </Stack>
    );
  }

  return <></>;
};
